var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28891 13.25L12.9043 21.8655C13.1521 22.1132 13.2745 22.4032 13.2714 22.7355C13.2681 23.0677 13.1372 23.3631 12.8789 23.6217C12.6203 23.8631 12.3275 23.9881 12.0006 23.9967C11.6736 24.0053 11.3809 23.8803 11.1222 23.6217L0.555156 13.0546C0.399045 12.8985 0.289045 12.7339 0.225156 12.5609C0.160989 12.3878 0.128906 12.2009 0.128906 12C0.128906 11.7992 0.160989 11.6123 0.225156 11.4392C0.289045 11.2662 0.399045 11.1016 0.555156 10.9455L11.1222 0.378384C11.3531 0.147551 11.6389 0.029495 11.9797 0.0242172C12.3206 0.0189395 12.6203 0.136995 12.8789 0.378384C13.1372 0.636995 13.2664 0.93394 13.2664 1.26922C13.2664 1.60477 13.1372 1.90185 12.8789 2.16047L4.28891 10.75H23.2506C23.6053 10.75 23.9022 10.8698 24.1414 11.1092C24.3809 11.3484 24.5006 11.6453 24.5006 12C24.5006 12.3548 24.3809 12.6517 24.1414 12.8909C23.9022 13.1303 23.6053 13.25 23.2506 13.25H4.28891Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.552f322ecf4e20503a8041047cdcf64c.svg";
export { ForwardRef as ReactComponent };